import { AutoMap } from "@automapper/classes";
import { PlanningConfigurationDTO } from "./planning-configuration.dto";
import { CompetenceDTO } from "./competence.dto";

export class UserDTO {
    @AutoMap()
    email!: string;
    @AutoMap()
    password!: string;
    @AutoMap()
    phone!: string;
    @AutoMap()
    firstName!: string;
    @AutoMap()
    lastName!: string;
    @AutoMap()
    puid!: string;
    @AutoMap()
    planningConfiguration: PlanningConfigurationDTO = new PlanningConfigurationDTO();
    @AutoMap(() => [CompetenceDTO])
    competenceList: CompetenceDTO[] = [];
}
